import { useVideoInfoModel } from './video-info.model'
import type { IVideoInfoProps } from './video-info.types'
import { VideoInfoView } from './video-info.view'

export function VideoInfo({ video }: IVideoInfoProps) {
  const videoInfo = useVideoInfoModel({ video })

  return <VideoInfoView {...videoInfo} />
}
